/** Record and change IDs are made on the device (offline creation, brief section 3). */
export function newId(): string {
  return crypto.randomUUID();
}
